/* --------------- *** Constants *** --------------- */

const SELECTOR_ARTICLE_GRID = "#article-grid";
const SELECTOR_CARD_MEDIA = ".card-article__media";
const ATTR_MEDIA_BOUND = "data-blog-media-bound";
const CLASS_MEDIA_READY = "is-media-ready";
const REVEAL_FALLBACK_MS = 3000;

/* --------------- *** Blog Card Media *** --------------- */

/**
 * Reveals a card-media element once its image has loaded.
 * Prevents flash of unstyled content in the blog article grid.
 */
const revealWhenReady = (media) => {
  if (media.getAttribute(ATTR_MEDIA_BOUND) === "1") return;

  media.setAttribute(ATTR_MEDIA_BOUND, "1");

  const img = media.querySelector("img");

  if (!img) {
    media.classList.add(CLASS_MEDIA_READY);
    return;
  }

  if (img.complete && img.naturalWidth > 0) {
    media.classList.add(CLASS_MEDIA_READY);
    return;
  }

  const fallbackTimer = window.setTimeout(() => {
    media.classList.add(CLASS_MEDIA_READY);
  }, REVEAL_FALLBACK_MS);

  const handleDone = () => {
    window.clearTimeout(fallbackTimer);
    media.classList.add(CLASS_MEDIA_READY);
  };

  img.addEventListener("load", handleDone, { once: true });
  img.addEventListener("error", handleDone, { once: true });
};

/* --------------- *** Initialisation *** --------------- */

const initCardMedia = (root) => {
  const el = root ?? document.querySelector(SELECTOR_ARTICLE_GRID);

  if (!(el instanceof Element)) return;

  el.querySelectorAll(SELECTOR_CARD_MEDIA).forEach(revealWhenReady);
};

/* --------------- *** Bootstrap *** --------------- */

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => initCardMedia(), { once: true });
} else {
  initCardMedia();
}

document.addEventListener("shopify:section:load", (event) => {
  if (!(event.target instanceof Element)) return;

  const grid = event.target.querySelector(SELECTOR_ARTICLE_GRID);

  if (grid) initCardMedia(grid);
});

window.themeBlogInitCardMedia = (root) => {
  initCardMedia(root);
};
